<nav class="navbar navbar-expand-md">
  <a class="navbar-toggler d-lg-none" href="javascript:void(0);" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleNavbar()">
    <fa-icon icon="bars"></fa-icon>
  </a>
  @if (isAuthenticated()) {
    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed">
      <ul class="navbar-nav ml-auto">
        <li ngbDropdown class="nav-item dropdown pointer" display="dynamic" routerLinkActive="active" placement="bottom-right">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu">
            <span fxHide="true" fxShow.gt-sm>{{getFirstName()}}</span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="account-menu">
            <li class="dropdown-item text-muted">{{getFullName()}}</li>
            <li class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item" routerLinkActive="active"  (click)="router.navigateByUrl('settings/my-profile')">
                <fa-icon icon="wrench" fixedWidth="true"></fa-icon>
                <span class="ml-1" jhiTranslate="global.menu.account.settings">Settings</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item"  (click)="router.navigateByUrl('account/password')" routerLinkActive="active">
                <fa-icon icon="lock" fixedWidth="true"></fa-icon>
                <span class="ml-1" jhiTranslate="global.menu.account.password">Password</span>
              </a>
            </li>
            <li class="dropdown-divider"></li>
            @for (language of languages; track language) {
              <li>
                <a class="dropdown-item" (click)="changeLanguage(language)" href="javascript:void(0);">
                  <img alt="flag" class="flag-img" src="{{language | findLanguageFlagFromKey}}" />
                  <span class="ml-1">{{language | findLanguageFromKey}}</span>
                </a>
              </li>
            }
            <li class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item" routerLinkActive="active"  (click)="router.navigateByUrl('help')">
                <fa-icon icon="play" fixedWidth="true"></fa-icon>
                <span class="ml-1" jhiTranslate="global.menu.help">How-to videos</span>
              </a>
            </li>
            <li class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item" (click)="logout()" id="logout">
                <fa-icon icon="sign-out-alt" fixedWidth="true"></fa-icon>
                <span class="ml-1" jhiTranslate="global.menu.account.logout">Sign out</span>
              </a>
            </li>
          </ul>
        </li>
        <li>
          @if (avatarUrl) {
            <span>
              <img [src]="avatarUrl" class="profile-image rounded-circle" alt="Avatar">
            </span>
          }
        </li>
      </ul>
    </div>
  }
</nav>
